// 所有接口暴露的地方
import request from '../network'; // 引用network.js
import portUrl from '../wap-module/url'; // 引用url.js
import comTools from '../../assets/js/until'
const qs = require('qs');

/**
 * App初始化,获取项目所有接口
 */
// let wapApiUrls = '';
// let urlObj = comTools.getRequest();
// let data = {
//   app_pid: urlObj.glPid || 100,
//   app_gid: urlObj.glGid || 100000,
//   app_p_mid: urlObj.glPMid || '1',
//   app_mid: urlObj.glMid || '10000',
//   tm: comTools.getTm(),
//   client_type: urlObj.client || 'h5'
// };
// data.sign = comTools.querySort(data);
// let appRequest = request({
//   // url: portUrl.appInit
//   method: "post",
//   url: 'http://webapi.gamehl.my/api/v1/web/home',
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded'
//   },
//   data: qs.stringify(data),
// }).then(res => {
//   // console.log(res);
//   return res
// }).catch(error => {
//   console.log(error);
// });
// 设备上报
const device = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
    url: portUrl.device
  })
}
// 首页
const home = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.home
  })
}
// 搜索
const search = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.search
  })
}
// (折扣，新游，热门)更多,需要分页
const gameMore = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.gameMore
  })
}
// h5游戏,需要分页
const gameH5 = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.gameH5
  })
}
// 分类-类别列表
const typesList = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.typesList
  })
}
// 分类-类别对应的游戏列表
const classifyList = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.classifyList
  })
}
// 排行版
const gameRank = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.gameRank
  })
}
// 游戏详情
const gameDetail = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.gameDetail
  })
}
// 攻略列表
const strategyList = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.strategyList
  })
}
// 攻略详情
const strategyDetail = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.strategyDetail
  })
}
// 礼包列表
const activityList = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.activityList
  })
}
// 活动详情
const activityDetail = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.activityDetail
  })
}
// 底部栏折扣和热门
const discount_hot = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.discount_hot
  })
}
// 详情页领取礼包
const giftGet = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.giftGet
  })
}
// 底部栏礼包列表
const giftList = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.giftList
  })
}
// 底部栏礼包详情
const giftDetail = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.giftDetail
  })
}
// 底部栏更多礼包列表
const giftTypeList = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.giftTypeList
  })
}
// 注册
const mobileReg = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.mobileReg
  })
}
// 忘记密码||找回密码
const forgetPwd = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.forgetPwd
  })
}
// 账号密码登录
const pwdLogin = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.pwdLogin
  })
}
// 验证码登录
const codeLogin = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.codeLogin
  })
}
// 发送验证码
const sendCode = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.sendCode
  })
}
// 我的页面
const mine = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.mine
  })
}
// 玩过的游戏
const playedGame = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.playedGame
  })
}
// 游戏余额
const gameBalance = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.gameBalance
  })
}
// 游戏余额
const balanceGame = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.balanceGame
  })
}
// 充值记录
const payRecord = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.payRecord
  })
}
// 充值记录-查询游戏
const payGame = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.payGame
  })
}
// 充值记录-查询账号
const payUser = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.payUser
  })
}
// 已领取的礼包
const gotGift = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.gotGift
  })
}
// 实名认证
const idAuth = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.idAuth
  })
}
// 修改密码
const modifyPwd = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.modifyPwd
  })
}
// 平台用户账户列表
const balanceUser = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.balanceUser
  })
}
// 改修昵称
const modifyNick = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.modifyNick
  })
}
// 我的消息
const news = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.news
  })
}
// 我的消息详情
const newDetail = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.newDetail
  })
}
// 消息推送
const newsPush = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.newsPush
  })
}
// 客服
const service = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.service
  })
}
// 更新下载量
const download = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.download
  })
}
// ios归属
const bindIos = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.bindIos
  })
}

// 平台币充值初始化
const platformRecharge = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.platformRecharge
  })
}

// 平台币支付
const platformPay = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.platformPay
  })
}

export default {
  device,
  home,
  search,
  gameMore,
  gameH5,
  typesList,
  classifyList,
  gameRank,
  gameDetail,
  strategyDetail,
  strategyList,
  activityList,
  activityDetail,
  discount_hot,
  giftList,
  giftDetail,
  giftTypeList,
  giftGet,
  mobileReg,
  forgetPwd,
  pwdLogin,
  sendCode,
  codeLogin,
  mine,
  modifyNick,
  playedGame,
  gameBalance,
  balanceGame,
  balanceUser,
  payGame,
  payUser,
  payRecord,
  idAuth,
  modifyPwd,
  news,
  newDetail,
  gotGift,
  service,
  newsPush,
  download,
  bindIos,
  platformRecharge,
  platformPay,
}